import axios from '../index'

export default {
    // BECAS Y DESCUENTOS
    getBecasDescuentosDetalle (params) {
        return axios.get('/indicadores/becas_y_descuentos_detalle', {params})
    },
    getBecasDescuentosGlobal (params) {
        return axios.get('/indicadores/becas_y_descuentos_global', {params})
    },
    

    // USABILIDAD SIGeM
    getCiclosEscolaresUsabilidad(){
        return axios.get('/ciclos-escolares/listado')
    },
    getInstitucionesUsabilidad(id){
        return axios.get('/instituciones/porCicloEscolar/' + id)
    },
    getUsabilidadSigem(params){
        return axios.get('/indicadores/getUsabilidad', {params})
    }

}